// Default SVG for logo (from EmailLogo.vue)
export const DEFAULT_LOGO_SVG = `<img src="https://storage.googleapis.com/cdn.orderprotection.com/Images/mountain-logo.png" alt="Order Protection EmailLogo" style="width: 29px; height: 23px;" />`;

// Default SVGs for icons (add more as needed)
export const DEFAULT_ICONS_SVG = {
  approved: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="56" height="57" id="shield-check"><path fill="#000000" d="M19.63,3.65a1,1,0,0,0-.84-.2,8,8,0,0,1-6.22-1.27,1,1,0,0,0-1.14,0A8,8,0,0,1,5.21,3.45a1,1,0,0,0-.84.2A1,1,0,0,0,4,4.43v7.45a9,9,0,0,0,3.77,7.33l3.65,2.6a1,1,0,0,0,1.16,0l3.65-2.6A9,9,0,0,0,20,11.88V4.43A1,1,0,0,0,19.63,3.65ZM18,11.88a7,7,0,0,1-2.93,5.7L12,19.77,8.93,17.58A7,7,0,0,1,6,11.88V5.58a10,10,0,0,0,6-1.39,10,10,0,0,0,6,1.39ZM13.54,9.59l-2.69,2.7-.89-.9a1,1,0,0,0-1.42,1.42l1.6,1.6a1,1,0,0,0,1.42,0L15,11a1,1,0,0,0-1.42-1.42Z"></path></svg>`,
  denied: '',
  extendedWarranty: '',
  orderProtected: '',
  received: '',
  storeCredit: '',
  unread: '',
};

// Design constants
export const DESIGN = {
  colors: {
    background: {
      black: '#000000',
      neutral: '#F1F3F9',
      white: '#FFFFFF',
    },
    border: {
      light: '#E1E6EF',
    },
    text: {
      primary: '#000000',
      secondary: '#A3A9B7',
      white: '#FFFFFF',
    },
  },
  fonts: {
    family: {
      primary: 'Arial, sans-serif',
    },
    style: {
      none: 'none',
    },
    weight: {
      bold: 'bold',
      regular: 'regular',
    },
  },
  spacing: {
    buttonBorderRadius: 0,
    desktopLogoWidth: 75,
  },
  typography: {
    headline: {
      desktop: {
        fontSize: 24,
        letterSpacing: 0,
        lineHeight: 1,
      },
      mobile: {
        fontSize: 28,
        letterSpacing: 0,
        lineHeight: 1,
      },
    },
    paragraph: {
      desktop: {
        fontSize: 24,
        letterSpacing: 0,
        lineHeight: 1.5,
      },
      mobile: {
        fontSize: 14,
        letterSpacing: 0,
        lineHeight: 1,
      },
    },
  },
} as const;

export const EMAIL_TEMPLATES = {
  approved: {
    buttonLink: '#',
    buttonText: 'View my claim',
    headline: 'Your claim has been approved.',
    mainText: 'Great news, [[customerName]]! We have approved your claim for your order [[storeOrderNumber]].',
    subText: (storeName: string) => `Thanks again for choosing ${storeName}.`,
    templateName: 'customer_claim_approved',
    title: 'Approved',
  },
  denied: {
    buttonLink: '#',
    buttonText: 'View my claim',
    headline: 'Sorry, but your claim has been denied.',
    mainText:
      'Hi, [[customerName]]. Unfortunately, the claim for your order [[orderNumber]] has been denied due to [[reason]].',
    subText: '',
    templateName: 'customer_claim_denied',
    title: 'Denied',
  },
  extendedWarranty: {
    buttonLink: '#',
    buttonText: 'File a claim',
    headline: 'Your products are covered!',
    mainText:
      'Great news - your order items are covered by our extended warranty.\n\nBecause you chose a premium warranty option, you now have access to a total of [[warrantyDuration]] of full coverage on the following items:',
    subText:
      'Please review your coverage terms <a href="[[coverageTermsUrl]]" style="color: #000; text-decoration: underline;">here</a>.\n\nIf you need support with your items, please file a claim using the link below.',
    templateName: 'extended_warranty_covered',
    title: 'Extended Warranty',
  },
  inactive: {
    buttonLink: '#',
    buttonText: 'View my claim',
    headline: 'Hi [[customerName]],',
    mainText:
      "We haven't heard back from you in [[daysInPendingNoResponse]] days. We are going to set this claim aside for now but if it still needs our attention, please reply to this message and we will get back to you soon! <br><br> Have a great day!",
    subText: (storeName: string) => ``,
    templateName: 'customer_close_inactive_claim',
    title: 'Inactive',
  },
  orderProtected: {
    buttonLink: '#',
    buttonText: 'File a claim',
    headline: 'Your order [[storeOrderId]] is protected.',
    mainText:
      "Your order is fully protected against theft, damaged items, missing items, lost packages, wrong items, or returned to sender.<br><br><b>Shipping or order issues?</b> <br>We're here to help, just tell us what happened.",
    subText: '',
    templateName: 'covered',
    title: 'Order Protected',
  },
  received: {
    buttonLink: '#',
    buttonText: 'View my claim',
    headline: 'We received your claim!',
    mainText: "We're currently reviewing your [[store]] claim on order [[storeOrderId]].",
    subText: (storeName: string) =>
      `We'll follow up with a resolution or additional questions typically within the next hour. Please give us a maximum of 24 hours to get back to you!<br><br> If you don't receive a response in the next 24 hours, feel free to reply to this email.`,
    templateName: 'customer_new_claim',
    title: 'Received',
  },
  storeCredit: {
    buttonLink: '[[storeUrl]]',
    buttonText: 'Start Shopping',
    headline: 'Your store credit reimbursement is here!',
    mainText: '',
    subText: (storeName: string) =>
      `Please find your store credit code enclosed as a reimbursement for your recent claim <b>#[[claimId]]</b> on your order <b>#[[sourceOrderNumber]] with [[brandName]]</b>.`,
    templateName: 'discount_code_created',
    title: 'Store Credit',
  },
  unread: {
    buttonLink: '#',
    buttonText: 'View my claim',
    headline: 'You have an unread message.',
    mainText: '',
    subText: '',
    templateName: 'customer_new_message',
    title: 'Unread',
  },
};

export const ADMIN_EMAIL_CONTENT = {
  approved: {
    content1: 'Great news, [[customerName]]! We have approved your claim for your order [[storeOrderNumber]].',
    content2: 'Thanks again for choosing Portland Leather.',
    title: 'Your claim has been approved!',
  },
  denied: {
    content1: 'Unfortunately, we were unable to approve your claim for order [[orderNumber]].',
    content2: 'If you have questions, please contact support.',
    title: 'Your claim was denied.',
  },
  extendedWarranty: {
    content1: 'Great news - your order items are covered by our extended warranty.',
    content2: 'If you need support with your items, please file a claim.',
    title: 'Your products are covered!',
  },
  orderProtected: {
    content1: 'Your order is now protected with Order Protection.',
    content2: '',
    title: 'Your order is protected!',
  },
  received: {
    content1: "We're currently reviewing your [[store]] claim on order [[storeOrderId]].",
    content2: 'Thanks again for choosing Portland Leather.',
    title: 'We received your claim.',
  },
  storeCredit: {
    content1: 'Store credit has been issued for your order [[sourceOrderNumber]].',
    content2: '',
    title: 'You have received store credit.',
  },
  unread: {
    content1: "If you haven't received a response within 24 hours, please don't hesitate to reply to this email.",
    content2: '',
    title: 'You have an unread message.',
  },
} as const;

export const ADMIN_SECTION_LABELS = {
  approved: 'OP Admin Only - Approved Email Content',
  denied: 'OP Admin Only - Denied Email Content',
  extendedWarranty: 'OP Admin Only - Extended Warranty Email Content',
  orderProtected: 'OP Admin Only - Order Protected Email Content',
  received: 'OP Admin Only - Received Email Content',
  storeCredit: 'OP Admin Only - Store Credit Email Content',
  unread: 'OP Admin Only - New Message Email Content',
} as const;
